/**
 * The door (2026-10-04): while Contruly opens by invitation, the server
 * refuses a stranger's account before it exists (hook_invite_only_signups,
 * migration 20261004230000), and send-otp asks the same function before it
 * creates one. Both answer with this sentence. The sign-in page recognises
 * it to show the waitlist instead of a red error, because the person did
 * nothing wrong.
 *
 * The sentence is owned by the SQL function; this copy exists so the page
 * can recognise it, and operatorDesk.parity asserts the two are equal.
 */
export const DOOR_WORD =
  'Contruly is open by invitation for now. Join the waitlist at contruly.com and we will write when your place is ready.';

export function isDoorRefusal(message: string | null | undefined): boolean {
  return !!message && /open by invitation/i.test(message);
}

/**
 * The refusal inside a failed `functions.invoke('send-otp')`: a 403 whose
 * body carries the sentence. Anything else (a 500, a network failure, a
 * rate limit) is not the door and returns null, so the caller keeps its
 * fallback.
 */
export async function doorRefusalFrom(error: unknown): Promise<string | null> {
  const ctx = (error as { context?: Response } | null)?.context;
  if (!ctx || typeof ctx.status !== 'number' || ctx.status !== 403) return null;
  try {
    const body = (await ctx.clone().json()) as { error?: string } | null;
    return body?.error && isDoorRefusal(body.error) ? body.error : null;
  } catch {
    return null;
  }
}
